import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from './contexts/AuthContext';
import HomeLayout from './Layouts/HomeLayout';
import AboutLayout from './Layouts/AboutLayout';
import ProductsLayout from './Layouts/ProductsLayout';
import ContactLayout from './Layouts/ContactLayout';
import FaqLayout from './Layouts/FaqLayout';
import ScrollToTop from './Components/scrolltop/ScrollTop';
import TermsLayout from './Layouts/TermsLayout';
import PrivacyLayout from './Layouts/PrivacyLayout';
import RefundLayout from './Layouts/RefundLayout';
import SecurityLayout from './Layouts/SecurityLayout';
import CookiesLayout from './Layouts/CookiesLayout';
import NewsLayout from './Layouts/NewsLayout';
import ProfileLayout from './Layouts/ProfileLayout';
import { Toaster } from 'react-hot-toast';
import NewsDetailsComp from './Components/newsdetailssection.jsx/NewsDetailsComp';
import ViewAuctions from './Components/viewactiveauctions/ViewAuctions';
import AuctionDetailsLayout from './Layouts/AuctionDetailsLayout';
import SavedAuctionView from './Components/savedauctiondetails/SavedAuctionView';
import PrivateAuctionView from './Components/savedprivateauction/PrivateAuctionView';
import ProtectedRoute from './Components/protectedroute/ProtectedRoute';



function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" reverseOrder={false} />
      <BrowserRouter>
        <div className="app-container">
          <div className="main-content">
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<HomeLayout />} />
              <Route path="/home" element={<HomeLayout />} />
              <Route path="/aboutus" element={<AboutLayout />} />
              <Route path="/auction" element={<ProductsLayout />} />
              <Route path="/faq" element={<FaqLayout />} />
              <Route path="/news" element={<NewsLayout />} />
              <Route path="/contactus" element={<ContactLayout />} />
              <Route path="/terms&conditions" element={<TermsLayout />} />
              <Route path="/privacypolicy" element={<PrivacyLayout />} />
              <Route path="/refundpolicy" element={<RefundLayout />} />
              <Route path="/securitypolicy" element={<SecurityLayout />} />
              <Route path="/cookiespolicy" element={<CookiesLayout />} />
              <Route 
                path="/userprofile" 
                element={
                  <ProtectedRoute>
                    <ProfileLayout />
                  </ProtectedRoute>
                } 
              />
              <Route path="/newsdetails" element={
                <ProtectedRoute>
                  <NewsDetailsComp />
                </ProtectedRoute>
              } />
              <Route path="/viewauctions" element={
                <ProtectedRoute>
                  <ViewAuctions />
                </ProtectedRoute>
              } />
              <Route path="/auctiondetails" element={
                <ProtectedRoute>
                  <AuctionDetailsLayout />
                </ProtectedRoute>
              } />
              <Route path="/savedauctionview" element={
                <ProtectedRoute>
                  <SavedAuctionView />
                </ProtectedRoute>
              } />
              <Route path="/privateauctionview" element={
                <ProtectedRoute>
                  <PrivateAuctionView />
                </ProtectedRoute>
              } />
              <Route path="/newsdetailssection/:id" element={<NewsDetailsComp />} />
              <Route path="/auctiondetails/:id" element={<AuctionDetailsLayout />} />
              <Route path="/viewactiveauctions/:id" element={<ViewAuctions />} />
              <Route path="/savedauctiondetails/:id" element={<SavedAuctionView />} />
              <Route path="/privateauctiondetails/:id" element={<PrivateAuctionView />} />
              {/* Add a catch-all route for 404 */}
              <Route path="*" element={<Navigate to="/home" replace />} />
            </Routes>
          </div>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
